
export default {
  ACCOUNT_BALANCE: 0,
  LEAD_ALERT_SETTINGS: {
    mobileSms: '',
    marketplaceEmailEnabled: false,
    marketplaceSmsEnabled: false,
    leadsBySms: false,
    leadsByEmail: false,
    marketplaceNotify: 0,
    smsMarketplaceNotify: 0,
    leadEmails: [],
  },
  MAIN_LISTING: null,
  COMPANY: null,
}
